// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2ZcI7","vLegacy":"SelectSecondary_vLegacy__2GBTz","error":"SelectSecondary_error__1ofpH","disabled":"SelectSecondary_disabled__3UfKQ"};